import { H4, Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Utils";

const ToDoUserProfile = () => {
  return (
    <div className="d-flex align-items-center flex-wrap">
      <div className="media-size-email">
        <Image className="me-3 rounded-circle" src={dynamicImage(`user/user.png`)} alt="avatar" />
      </div>
      <div className="flex-grow-1">
        <H4>{"Mark Jecno"}</H4>
        <P>{"Markjecno@gmail.com"}</P>
      </div>
    </div>
  );
};

export default ToDoUserProfile;
